export default "__VITE_ASSET__Bk$pmKWY__"